import { defineMessages } from 'react-intl';

export const projectMessageActionsMessages = defineMessages({
  thumbUpTitle: {
    defaultMessage: 'What did you like?',
    id: 'hYdswNu5cc',
    description: 'Popover title when submitting positive project reply feedback',
  },
  thumbDownTitle: {
    defaultMessage: 'What went wrong?',
    id: 'UZOSovME05',
    description: 'Popover title when submitting negative project reply feedback',
  },
  thumbUpPlaceholder: {
    defaultMessage: 'Tell Heidi what worked well (optional)',
    id: '33hDjyuZvx',
    description: 'Optional comment placeholder for positive project reply feedback',
  },
  thumbDownPlaceholder: {
    defaultMessage: 'Tell Heidi how this could be better (optional)',
    id: '/4Nm+gPMN4',
    description: 'Optional comment placeholder for negative project reply feedback',
  },
  thanksForFeedback: {
    defaultMessage: 'Thanks for the feedback',
    id: 'LHUIFokoMd',
    description: 'Toast after project reply feedback is submitted successfully',
  },
  couldntSubmitFeedback: {
    defaultMessage: "Couldn't submit feedback",
    id: 'Vh5CSvNGmN',
    description: 'Toast title when project reply feedback submission fails',
  },
  pleaseTryAgain: {
    defaultMessage: 'Please try again.',
    id: 'JTgsJpqBev',
    description: 'Toast description when project reply feedback submission fails',
  },
  copy: {
    defaultMessage: 'Copy',
    id: 'R+QabMZW9I',
    description: 'Accessible label for copying a project assistant reply',
  },
  // No description — that's what makes this reuse the shared, translated `Copied` id.
  copied: {
    defaultMessage: 'Copied',
    id: 'p556q3uvbn',
  },
  error: {
    defaultMessage: 'Error',
    id: 'Ks8urLPlgo',
    description: 'Toast title when copying a project assistant reply fails',
  },
  failedToCopy: {
    defaultMessage: 'Failed to copy',
    id: 'MM3t+iZkvV',
    description: 'Toast description when copying a project assistant reply fails',
  },
  // The five below are the SAME message identities Chat's FeedbackPopover
  // renders (`src/components/chat/components/FeedbackPopover.messages.ts`).
  // The ids are copied VERBATIM, never re-minted, so Crowdin resolves one
  // translation for both surfaces — the id is the contract, the module is only
  // its carrier (same pattern as `copied` above). Declaring them here is what
  // lets Work's message actions stop importing out of the Chat quarantine.
  positiveTooltip: {
    defaultMessage: 'Good response',
    id: 'IWdvGu7/1g',
    description: 'Tooltip shown when hovering the positive feedback button',
  },
  negativeTooltip: {
    defaultMessage: 'Bad response',
    id: '3u4IJI5Ihg',
    description: 'Tooltip shown when hovering the negative feedback button',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'djwGFrg/UA',
    description: 'Secondary action to dismiss the feedback popover without submitting',
  },
  submit: {
    defaultMessage: 'Submit',
    id: 'Denx7Jn28C',
    description: 'Primary action to send feedback from the popover',
  },
  submitting: {
    defaultMessage: 'Submitting...',
    id: 'vGCJ0Yw9uL',
    description: 'Submit button label while feedback is being sent',
  },
});
